import { Stack, Typography } from '@mui/material';
import React, { FC, ReactNode } from 'react';

import { PageHeader, PageHeaderProps } from '@sbu/components.pageheader';
import { Divider } from '@sumologic/yama-ds-components';

import { Count } from 'shared/components/data/Count';

type GridHeaderProps = PageHeaderProps & {
  actions?: ReactNode;
  searchFilter?: ReactNode;
  sortMenu?: ReactNode;
  subMenu?: ReactNode;
  title: ReactNode;
  total?: number | null;
};

export const GridHeader: FC<React.PropsWithChildren<GridHeaderProps>> = ({
  actions,
  title,
  total,
  searchFilter,
  sortMenu,
  subMenu,
  leftContent: leftContentProp = [],
  rightContent: rightContentProp = [],
  ...rest
}) => {
  const hasTotal = total !== null;

  const leftContent: ReactNode[] = [
    ...(hasTotal
      ? [
          <Stack
            key='grid-total'
            whiteSpace='nowrap'
            direction='row'
            alignItems='center'
            height='60'
          >
            {total !== null && (
              <Stack gap={0.5} alignItems='center' minWidth={30}>
                <Typography fontSize='1.75rem' lineHeight='1.25rem'>
                  {total === undefined && <>&nbsp;</>}
                  {total !== undefined && (
                    <Count
                      animated={true}
                      suffixPadding={false}
                      value={total}
                    />
                  )}
                </Typography>
                {total !== undefined && (
                  <Typography
                    color='text.secondary'
                    component='label'
                    display='block'
                  >
                    Total
                  </Typography>
                )}
              </Stack>
            )}
          </Stack>,
        ]
      : []),
    ...(subMenu ? [subMenu] : []),
    ...(searchFilter
      ? [
          <Stack
            key='grid-search-filter'
            direction='row'
            minHeight={60}
            flexGrow={1}
          >
            {searchFilter}
            <Divider orientation='vertical' flexItem sx={{ ml: 2 }} />
          </Stack>,
        ]
      : []),

    ...leftContentProp,
  ];

  const rightContent: ReactNode[] = [
    ...(sortMenu ? [sortMenu] : []),
    ...(actions ? [actions] : []),
    ...rightContentProp,
  ];

  return (
    <PageHeader
      title={title}
      leftContent={leftContent}
      rightContent={rightContent}
      sx={{
        mb: 2,
        minHeight: 60,
        position: 'relative',
        zIndex: 2,
      }}
      {...rest}
    />
  );
};
